// Auto-generated from old repo translations - do not edit by hand
const en: Record<string, string> = {
  'site.title': 'CreatiCode: Scratch + AI + 3D',
  'site.meta.description': 'Scratch + AI + 3D | Free Playground and Tutorials',
  'site.meta.keywords':
    'Free Playground, Tutorials, 3D models, 3D programming, 3D Games, Metaverse, Scratch, Creativity, 3D, Game, Coding, Problem Solving, Design Thinking',
  'site.meta.og:title': 'CreatiCode: Scratch + AI + 3D | Free Playground and Tutorials',
  'logo.white': 'newlogo200.png',
  'logo.whiteLarge': 'newlogo400.png',
  'logo.green': 'creaticodeword_en_300.png',
  'logo.greenLarge': 'creaticodeword_en_600.png',
  'logo.logo': 'en-logo.png',
  'WhyBanner.mainTitle': 'Why Choose CreatiCode?',
  'WhyBanner.creativeTitle': 'Compatible with\nMIT Scratch',
  'WhyBanner.creativeContent':
    'Our platform is built upon the open-source version of MIT Scratch 3.0, with many new features that make you more productive. You will find it very easy to get started.',
  'WhyBanner.contactTitle': 'Simplified\n3D Language',
  'WhyBanner.contactContent':
    'We have designed a system of easy-to-understand blocks for 3D programming, so you do not have to learn another complex coding language or interface.',
  'WhyBanner.focusTitle': 'Self-paced\nLessons',
  'WhyBanner.focusContent':
    'We offer scaffolded micro-lessons with targeted practice projects, so you take control of your learning path and pace based on your own time and readiness.',
  'WhyBanner2.mainTitle': 'Why 3D Programming?',
  'WhyBanner2.creativeTitle': 'An Engaging and Fun Experience',
  'WhyBanner2.creativeContent':
    'Building 3D projects are just like playing games, with infinitely large virtual worlds, realistic objects/characters, freely moving cameras, and engaging user interactions.',
  'WhyBanner2.contactTitle': 'Comprehensive Whole-Brain Training',
  'WhyBanner2.contactContent':
    'Working on 3D projects develops both the left brain (science, mathematics and logical reasoning) and the right brain (creative design and spatial reasoning).',
  'WhyBanner2.focusTitle': 'Cutting-Edge Technologies of the Future',
  'WhyBanner2.focusContent':
    '3D programming is the key to unlock many exciting emerging technologies, such as Metaverse (VR/AR), Computer-Aided Design (CAD) and 3D printing.',
  'WhyBanner2.creativeTag': 'Learn by Creating',
  'WhyBanner2.contactTag': 'Build Both Sides',
  'WhyBanner2.focusTag': 'Future-Ready Skills',
  'WhyBanner3.mainTitle': 'Why AI?',
  'WhyBanner3.creativeTitle': 'Endless AI Learning Opportunities',
  'WhyBanner3.creativeContent':
    'AI opens a world of learning opportunities. From basic concepts to advanced techniques, students can expand their skills in a rapidly evolving field.',
  'WhyBanner3.contactTitle': 'Empowering Future AI Innovators',
  'WhyBanner3.contactContent':
    'Learning AI equips students with the tools to innovate, and helps them solve real-world problems and drive technological advancements.',
  'WhyBanner3.focusTitle': 'Understanding Ethical\nChallenges',
  'WhyBanner3.focusContent':
    'Learning AI helps students understand ethics like bias and privacy. It also dispels fears about AI replacing humans, clarifying its true capabilities.',
  'VideoBannerTop.sectionTitle': 'See CreatiCode in Action',
  'VideoBannerTop.creativeTitle': 'Enhanced 2D\nScratch Playground',
  'VideoBannerTop.contactTitle': '3D Scratch\nPlayground',
  'VideoBannerTop.focusTitle': 'Self-paced\nCurriculum',
  'VideoBannerTop.creative.title': 'Enhanced 2D\nScratch Playground',
  'VideoBannerTop.creative.mediaLink': 'https://videos.creaticode.com/enhanced-2d-scratch-playground.mp4',
  'VideoBannerTop.contact.title': '3D Scratch\nPlayground',
  'VideoBannerTop.contact.mediaLink': 'https://videos.creaticode.com/3d-scratch-playground.mp4',
  'VideoBannerTop.focus.title': 'Self-paced\nCurriculum',
  'VideoBannerTop.focus.mediaLink': 'https://videos.creaticode.com/self-paced-curriculum.mp4',
  'VideoBannerTop.creativeCN.title': 'Write 3D programs\nwith Scratch blocks',
  'VideoBannerTop.creativeCN.mediaLink': '//player.bilibili.com/player.html?aid=605135896&bvid=BV1m84y1y7kx&cid=892225349&page=1',
  'VideoBannerTop.contactCN.title': '3D Scratch\n游乐场',
  'VideoBannerTop.contactCN.mediaLink': '//player.bilibili.com/player.html?aid=605135896&bvid=BV1m84y1y7kx&cid=892225349&page=1',
  'VideoBannerTop.focusCN.title': '自学课程',
  'VideoBannerTop.focusCN.mediaLink': '//player.bilibili.com/player.html?aid=605135896&bvid=BV1m84y1y7kx&cid=892225349&page=1',
  'TopBanner.creaticode': 'CreatiCode',
  'TopBanner.Header': 'CreatiCode: Scratch + AI + 3D',
  'TopBanner.BriefIntroduction.0': 'AI Tools',
  'TopBanner.BriefIntroduction.1': 'Code and Design',
  'TopBanner.BriefIntroduction.2': 'AI + 3D Projects',
  'TopBanner.SignUpButton': 'FREE SIGN UP',
  'TopBanner.menu': 'MENU',
  'TopBanner.NavBarButtons.games': 'GAMES',
  'TopBanner.NavBarButtons.courses': 'COURSES',
  'TopBanner.NavBarButtons.dashboard': 'DASHBOARD',
  'TopBanner.NavBarButtons.myStuff': 'MY STUFF',
  'TopBanner.NavBarButtons.leaderBoard': 'LEADERBOARD',
  'TopBanner.NavBarButtons.forum': 'FORUM',
  'TopBanner.NavBarButtons.about': 'ABOUT',
  'TopBanner.NavBarButtons.contact': 'CONTACT',
  'TopBanner.NavBarButtons.create': 'CREATE',
  'TopBanner.NavBarButtons.joinNow': 'SIGN UP <p>FREE</p>',
  'TopBanner.NavBarButtons.logout': 'LOG OUT',
  'TopBanner.NavBarButtons.signIn': 'LOG IN',
  'TopBanner.NavBarButtons.explore': 'EXPLORE',
  'TopBanner.NavBarButtons.olympic': 'OLYMPIC',
  'TopBanner.NavBarButtons.learn': 'LEARN',
  'TopBanner.NavBarButtons.hourOfCode': 'TUTORIALS',
  'TopBanner.guideLine': 'Drive: W/S/A/D\nStop/Flip: SPACE',
  'TopBanner.signIn': 'Login',
  'TopBanner.join': 'Join',
  'TopBanner.myStuff': 'My Stuff',
  'TopBanner.slogan': 'CreatiCode: Scratch + AI + 3D',
  'TopBanner.subtitle': 'AI and 3D coding made simple, creative, and fun.',
  'TopBanner.whatBody':
    'CreatiCode builds on Scratch 3.0 with kid-friendly AI and 3D tools. Students can generate images, get coding help, and use AI blocks to add vision, speech, chat, and other smart features to their projects.\n\nWith guided lessons and creative playgrounds, they can move from idea to working AI-powered project without learning a complex programming language.',
  'Hero.startCreatingFree': 'Start Creating Free',
  'Hero.watchDemo': 'Watch Demo',
  'Footer.Title.highlight': 'highlights',
  'Footer.Title.contact': 'Contact us',
  'Footer.Title.community': 'Community',
  'Footer.Title.connect': 'Stay Connected',
  'Footer.Title.linkWithSocial': 'Link with Social',
  'Footer.Highlight.about-us': 'About Us',
  'Footer.Highlight.contact': 'Contact',
  'Footer.Highlight.create': 'Create',
  'Footer.Highlight.explore': 'Explore',
  'Footer.Highlight.founder-story': 'Founder Story',
  'Footer.Highlight.advisor-team': 'Advisor Team',
  'Footer.Highlight.join-us': 'Join Us',
  'Footer.Highlight.forum': 'Forum',
  'Footer.Highlight.privacy-policy': 'Privacy Policy',
  'Footer.Highlight.tutorials': 'Tutorials',
  'Footer.CopyRight': 'All rights reserved',
  'Footer.Title.mission': 'Mission',
  'Footer.mission': 'Empower every learner to create, solve problems, and bring ideas to life with AI.',
  'DashBoardHeader.NavBarButtons.dashboard': 'DASHBOARD',
  'DashBoardHeader.NavBarButtons.games': 'GAMES',
  'DashBoardHeader.NavBarButtons.courses': 'COURSES',
  'DashBoardHeader.NavBarButtons.leaderBoard': 'LEADERBOARD',
  'DashBoardHeader.NavBarButtons.forum': 'FORUM',
  'DashBoardHeader.NavBarButtons.about': 'ABOUT',
  'DashBoardHeader.NavBarButtons.contact': 'CONTACT',
  'DashBoardHeader.NavBarButtons.create': 'CREATE',
  'DashBoardHeader.NavBarButtons.joinNow': 'FREE SIGN UP',
  'DashBoardHeader.NavBarButtons.logout': 'LOG OUT',
  'DashBoardHeader.NavBarButtons.admin': 'ADMIN',
  'DashBoardHeader.NavBarButtons.signIn': 'LOGIN',
  'DashBoardHeader.NavBarButtons.teacher': 'TEACHER',
  'DashBoardHeader.NavBarButtons.school': 'SCHOOL',
  'DashBoardHeader.NavBarButtons.migration': 'MIGRATION',
  'DashBoardHeader.NavBarButtons.explore': 'EXPLORE',
  'DashBoardHeader.NavBarButtons.olympic': 'OLYMPIC',
  'DashBoardHeader.NavBarButtons.learn': 'LEARN',
  'DashBoardHeader.NavBarButtons.hourOfCode': 'TUTORIALS',
  'DashBoardHeader.NavBarButtons.metrics': 'METRICS',
  'DashBoardHeader.NavBarButtons.setting': 'SETTING',
  'DashBoardHeader.NavBarButtons.discounts': 'DISCOUNTS',
  'DashBoardHeader.NavBarButtons.support': 'SUPPORT',
  'DashBoardHeader.language.en': 'English',
  'DashBoardHeader.language.zh': '简体中文',
  'DashBoardHeader.language.es': 'Español',
  'DashBoardHeader.language.fr': 'Français',
  'UpperFooter.title': 'Start Learning Today',
  'UpperFooter.subTitle': 'and be prepared for the world of AIs tomorrow',
  'UpperFooter.joinButton': 'Try it now',
  'ExampleProjects.title': 'Example Projects',
  'ExampleProjects.hint': 'Use the arrows or dots to explore more projects',
  'ExampleProjects.slides.rover.title': '3D Mars Rover',
  'ExampleProjects.slides.rover.content': "A rover that can unfold, move and turn on Mars's surface.",
  'ExampleProjects.slides.rover.image': 'marsdemo1_600.gif',
  'ExampleProjects.slides.solar.title': 'Solar System',
  'ExampleProjects.slides.solar.content': 'Simulation of the rotation and spin of planets in the solar system.',
  'ExampleProjects.slides.solar.image': 'solar.gif',
  'ExampleProjects.slides.magellan.title': 'The Magellan Expedition in 3D',
  'ExampleProjects.slides.magellan.content': "Follow Magellan's fleet to sail around the globe.",
  'ExampleProjects.slides.magellan.image': 'm2.gif',
  'ExampleProjects.slides.boymirror.title': 'Animated Characters',
  'ExampleProjects.slides.boymirror.content': 'A boy playing on a huge mirror.',
  'ExampleProjects.slides.boymirror.image': 'boy3.gif',
  'ExampleProjects.slides.d3maze.title': '3D Maze Game',
  'ExampleProjects.slides.d3maze.content': 'Driving a car out of a maze of walls.',
  'ExampleProjects.slides.d3maze.image': '3dmazedemo.gif',
  'ExampleProjects.slides.d3walkway.title': '3D Walkway',
  'ExampleProjects.slides.d3walkway.content': 'A floating walkway made of 3 flying bricks.',
  'ExampleProjects.slides.d3walkway.image': '3dwalkway.gif',
  'ExampleProjects.slides.d3bus.title': '3D Bus',
  'ExampleProjects.slides.d3bus.content': 'A fully-featured bus with wheels, windows, doors, and lights.',
  'ExampleProjects.slides.d3bus.image': 'busdemo.gif',
  'ExampleProjects.slides.ai.title': 'AI game players',
  'ExampleProjects.slides.ai.content':
    'Learn to play a game manually, then follow tutorials to build a game bot that automatically plays the game.',
  'ExampleProjects.slides.ai.image': 'MonkeyGame.gif',
  'ExampleProjects.slides.drawing.title': 'Drawing a Castle',
  'ExampleProjects.slides.drawing.content': 'A castle drawn with 2D pens.',
  'ExampleProjects.slides.drawing.image': 'castle1.gif',
  'ExampleProjects.slides.algorithms.title': 'Classic Algorithms',
  'ExampleProjects.slides.algorithms.content':
    'Master classic algorithms (e.g. sorting and searching) through unplugged activities and animated simulations.',
  'ExampleProjects.slides.algorithms.image': 'FootBallGame.gif',
  'ExampleProjects.slides.simulate.title': 'Simulate Real application',
  'ExampleProjects.slides.simulate.content': 'Build prototypes of various real-world AI solutions to understand basic AI applications.',
  'ExampleProjects.slides.simulate.image': 'PandaGame.gif',
  'ExampleProjects.slides.introducing.title': 'Introduction to AI Algorithms',
  'ExampleProjects.slides.introducing.content': 'Implement simplified AI projects to learn AI models and algorithms.',
  'ExampleProjects.slides.introducing.image': 'NumberDrawingGame.gif',
  changeLanguage: 'Change language',
};

export default en;
